import React from "react";
import PdfListPage from "./PdfListPage";
import { useRoe } from "./RoeLayout";

export default function Admissions() {
  const data = useRoe();
  return (
    <PdfListPage
      eyebrow="Join Us"
      title="Admission Notices"
      accent="coral"
      items={data.notices_admission || []}
      testid="roe-admissions"
      emptyMsg="Admission notices will appear here once published."
    />
  );
}
